import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

import { UntypedFormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ProDefiniciones } from '@shared/interfaces/request/proDefiniciones';
import { ProDefinicionesService } from '@p-p-portafolio/services/pro-definiciones.service';
import { TasasService } from '@p-p-portafolio/services/tasas.service';
import { UserService } from '@pages/user/services/user.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { SwalService } from '@shared/utils/swal.service';
import { DefinicionesFormComponent } from '../../../definiciones/definiciones-form/definiciones-form.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-def-subsidio',
  templateUrl: './def-subsidio.component.html',
  styleUrls: ['./def-subsidio.component.css']
})
export class DefSubsidioComponent implements OnInit {
  //#region Varibles

  @Input() modelRecived: ProDefiniciones;
  private _user: string = this._userServices.userCurrent;
  public promocion: string = localStorage.getItem('prom');
  public breakpoint: number;
  public tasas: any[];
  public accounting: any[];

  //#region Booleanos
  public formPrincipal: boolean = true;
  public selectTasa: boolean;
  public loading: boolean;
  //#endregion

  //#endregion

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<DefinicionesFormComponent>,
    private _swalService: SwalService,
    private _proDefServices: ProDefinicionesService,
    private _userServices: UserService,
    private _injectServices: InjectableService,
    private _tasasServices: TasasService,
    private renderer: Renderer2,
    private _snackBar: MatSnackBar,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.readAccounting();
    this.setForm();
    this.readTasas();
    this.injectTasa();
    this.onBreakPonit();
  }

  form = this._fb.group({
    promocion: [this.promocion],
    numVar: [
      '',
      {
        validators: [Validators.required, this.variableValidation()],
        asyncValidators: [this.singleDefinicion()],
        updateOn: 'blur'
      }
    ],
    descripcion: ['', Validators.required],
    claveTasa: ['', Validators.required],
    valorFijo: ['0.0', Validators.required],
    amortInf: [0],
    amortSup: [0],
    formula: [''],
    porcentaje: ['0.0', Validators.required],
    concepto: [0],
    conceptoAdicional: [0],
    user: this._user
  });

  //#region ValoresPromocion

  readAccounting() {
    let iTipo: number = 42;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.accounting = res.data;
    });
  }

  //#endregion

  //#region SelectTabla

  readTasas() {
    this._tasasServices.read().subscribe((res) => {
      this.tasas = res.data;
    });
  }

  injectTasa() {
    this._injectServices.disparadorTasas.subscribe((res) => {
      this.form.patchValue({ claveTasa: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }

  //#endregion

  //#region ChangeForm

  changeBoolean(change: string) {
    switch (change) {
      case 'form':
        this.selectTasa = false;
        this.formPrincipal = true;
        break;
      case 'tasas':
        this.formPrincipal = false;
        this.selectTasa = true;
        break;
    }
  }

  //#endregion

  //#region CRUD

  create(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      this._proDefServices.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else this._swalService.error('No Agregado');
      });
    }
  }

  update(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      this._proDefServices.update(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }

  //#endregion

  //#region Get Fb

  formValue(value: string) {
    return this.form.get(value);
  }

  //#endregion

  //#region Validations

  variableValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const variable = control.value;
      if (variable == null || variable === '') return null;
      if (variable >= 451 && variable <= 500) {
        return null;
      }

      this._snackBar.open('El rango de variables para Subsidio es de 451 a 500', 'cerrar', { duration: 5000 });
      const input = this.el.nativeElement.querySelector('#numVar');
      if (input) {
        this.renderer.addClass(input, 'is-invalid');
      }

      return { variableValidation: true };
    };
  }

  //#endregion

  //#region AsyncValidations

  singleDefinicion(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | any> => {
      if (this.modelRecived) return of(null);

      return this._proDefServices.readOne(this.promocion, control.value).pipe(
        tap(() => {
          const input = this.el.nativeElement.querySelector('#numVar');
          this.renderer.removeClass(input, 'is-invalid');
        }),
        map((res) => {
          const input = this.el.nativeElement.querySelector('#numVar');
          // 1 → la promoción no existe  ⇒  VÁLIDA
          if (res.exito === 1) {
            this.renderer.addClass(input, 'is-invalid'); // aura roja
            this._snackBar.open('Variable en uso, intente con otra.', 'cerrar', { duration: 5000 });
            return { singleDefinicion: true }; // ← objeto de error
          }
          // distinto de 1 → libre  ⇒  INVÁLIDA
          return null; // ← sin errores
        })
      );
    };
  }
  //#endregion

  //#region Options

  setForm(): void {
    if (this.modelRecived !== null) {
      let model: ProDefiniciones = this.modelRecived;
      const setModel = {
        promocion: model.promocion,
        numVar: model.numVar,
        descripcion: model.descripcion,
        claveTasa: model.claveTasa,
        valorFijo: model.valorFijo,
        amortInf: 0,
        amortSup: 0,
        formula: '',
        porcentaje: model.porcentaje,
        concepto: 0,
        conceptoAdicional: 0,
        user: this._user
      };
      this.form.setValue(setModel);
    }
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }

  //#endregion
}
